import { createSlice } from "@reduxjs/toolkit";

export const drawerSlice = createSlice({
  name: "drawer",
  initialState: {
    drawer: false,
  },
  reducers: {
    changeDrawer: (state, action) => {
      state.drawer = action.payload;
    },
  },
});

export const { changeDrawer } = drawerSlice.actions;
export const selectDrawer = (state: any) => state.drawer.drawer;
export default drawerSlice.reducer;
